import { format, parseISO } from "date-fns"
import type {
	AdminPostageStamp,
	AdminStampSheet,
	StockSummaryTier,
} from "@/types/marketplace.types"

export const PRODUCT_LABELS: Record<AdminPostageStamp["product"], string> = {
	lettre_internationale_suivie: "Lettre internationale suivie",
}

export const SHEET_STATUS_LABELS: Record<AdminStampSheet["status"], string> = {
	pending: "Queued",
	processing: "Processing",
	needs_review: "Needs review",
	done: "Done",
	failed: "Failed",
}

export const STAMP_STATUS_LABELS: Record<AdminPostageStamp["status"], string> =
	{
		review: "Review",
		available: "Available",
		reserved: "Reserved",
		used: "Used",
		voided: "Voided",
		expired: "Expired",
	}

export const STAMP_STATUSES = Object.keys(
	STAMP_STATUS_LABELS,
) as AdminPostageStamp["status"][]

const eur = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "EUR",
})

export function formatEuroCents(cents: number): string {
	return eur.format(cents / 100)
}

export function formatTier(weightMaxGrams: number): string {
	return `≤ ${weightMaxGrams} g`
}

export function tierName(tier: {
	product: AdminPostageStamp["product"]
	weightMaxGrams: number
}): string {
	return `${PRODUCT_LABELS[tier.product]} · ${formatTier(tier.weightMaxGrams)}`
}

export function formatIsoDay(iso: string): string {
	return format(parseISO(iso), "d MMM yyyy")
}

/** A tier needs an admin when stamps wait in review, or, unless muted, when it runs low or holds expired stamps. */
export function tierNeedsAction(tier: StockSummaryTier): boolean {
	if (tier.review > 0) {
		return true
	}
	return !tier.alertsMuted && (tier.lowStock || tier.expired > 0)
}
